// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../common/Components/Loader.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
let ChapterDashboardPropertyStats_query_graphql = require("../../__generated__/ChapterDashboardPropertyStats_query_graphql.bs.js");

let convertFragment = ChapterDashboardPropertyStats_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardPropertyStats_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardPropertyStats_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterDashboardPropertyStats_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardPropertyStats_query_graphql.node, convertFragment, fRef);
}

let QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ChapterDashboard__PropertyStats$CardBodyContainer(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      props.children,
      props.showSearchLink ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.Footer.make, {
            href: "/properties",
            linkText: "Search all broadcast properties"
          }),
          className: "mt-8"
        }) : null
    ]
  });
}

let CardBodyContainer = {
  make: ChapterDashboard__PropertyStats$CardBodyContainer
};

function ChapterDashboard__PropertyStats$EmptyState(props) {
  return JsxRuntime.jsx(ChapterDashboard__PropertyStats$CardBodyContainer, {
    showSearchLink: true,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.EmptyStateContainer.make, {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "There have been no properties added in your TAN chapter recently."
          }),
          JsxRuntime.jsx("p", {
            children: JsxRuntime.jsxs("span", {
              children: [
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                  href: "/client_needs/new",
                  children: "Add your buyers and renters"
                }),
                " so you won't miss new properties on TAN that match."
              ]
            })
          })
        ],
        className: "text-left space-y-7"
      })
    })
  });
}

let EmptyState = {
  EmptyStateContainer: undefined,
  make: ChapterDashboard__PropertyStats$EmptyState
};

function ChapterDashboard__PropertyStats$LoadingState(props) {
  return JsxRuntime.jsx(ChapterDashboard__PropertyStats$CardBodyContainer, {
    showSearchLink: false,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.LoadingStateContainer.make, {
      children: JsxRuntime.jsx(Loader.make, {})
    })
  });
}

let LoadingState = {
  make: ChapterDashboard__PropertyStats$LoadingState
};

function ChapterDashboard__PropertyStats$ErrorState(props) {
  return JsxRuntime.jsx(ChapterDashboard__PropertyStats$CardBodyContainer, {
    showSearchLink: true,
    children: JsxRuntime.jsx(DashboardCardComponents__Tw.EmptyStateContainer.make, {
      children: JsxRuntime.jsx("div", {
        children: "There was a problem loading the property stats",
        className: "flex items-center"
      })
    })
  });
}

let ErrorState = {
  EmptyStateContainer: undefined,
  make: ChapterDashboard__PropertyStats$ErrorState
};

function ChapterDashboard__PropertyStats$PropertyStatsWidget(props) {
  let sold = props.sold;
  let activePublic = props.activePublic;
  let activePrivate = props.activePrivate;
  if (activePublic === 0 && activePrivate === 0 && sold === 0) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$EmptyState, {});
  }
  return JsxRuntime.jsx(ChapterDashboard__PropertyStats$CardBodyContainer, {
    showSearchLink: true,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.StatsDisplayer.make, {
            href: "/properties",
            label: "Broadcast",
            value: activePublic,
            subLabel: "properties"
          }),
          className: " flex-1"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.StatsDisplayer.make, {
            label: "Quiet",
            value: activePrivate,
            subLabel: "properties"
          }),
          className: " flex-1"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DashboardCardComponents__Tw.StatsDisplayer.make, {
            href: "/properties?soldOrRented=true",
            label: "Sold / Rented",
            value: sold,
            subLabel: "last 90 days"
          }),
          className: " flex-1"
        })
      ],
      className: "flex flex-col md:flex-row gap-4"
    })
  });
}

let PropertyStatsWidget = {
  make: ChapterDashboard__PropertyStats$PropertyStatsWidget
};

function ChapterDashboard__PropertyStats(props) {
  let query = RescriptRelay_Fragment.useFragment(ChapterDashboardPropertyStats_query_graphql.node, convertFragment, props.query);
  let match = query.chapterPropertyStats;
  if (match === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
  let match$1 = match.activePrivate;
  if (match$1 === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
  let activePrivate = match$1.count;
  if (activePrivate === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
  let match$2 = match.activePublic;
  if (match$2 === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
  let activePublic = match$2.count;
  if (activePublic === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
  let match$3 = match.sold;
  if (match$3 === undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
  let sold = match$3.count;
  if (sold !== undefined) {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$PropertyStatsWidget, {
      activePrivate: activePrivate | 0,
      activePublic: activePublic | 0,
      sold: sold | 0
    });
  } else {
    return JsxRuntime.jsx(ChapterDashboard__PropertyStats$ErrorState, {});
  }
}

let DashboardCardComponents;

let make = ChapterDashboard__PropertyStats;

exports.DashboardCardComponents = DashboardCardComponents;
exports.QueryFragment = QueryFragment;
exports.CardBodyContainer = CardBodyContainer;
exports.EmptyState = EmptyState;
exports.LoadingState = LoadingState;
exports.ErrorState = ErrorState;
exports.PropertyStatsWidget = PropertyStatsWidget;
exports.make = make;
/* Loader Not a pure module */
